import { render, staticRenderFns } from "./FakeDisplayManager.vue?vue&type=template&id=a979b696&scoped=true&"
import script from "./FakeDisplayManager.vue?vue&type=script&lang=js&"
export * from "./FakeDisplayManager.vue?vue&type=script&lang=js&"
import style0 from "./FakeDisplayManager.vue?vue&type=style&index=0&id=a979b696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a979b696",
  null
  
)

export default component.exports